// extracted by mini-css-extract-plugin
export default {"root":"Controls__root--1Z9i4","upload":"Controls__upload--1Wm_Z","expand":"Controls__expand--YnX9S","expandClosed":"Controls__expandClosed--2zbcX","close":"Controls__close--2Y4Yr"};